// extracted by extract-css-chunks-webpack-plugin
module.exports = {"aligned":"_2Ny6Bb","grid":"_1q0kMV","centered-section-spacing":"_3g6x_z","grid-odd":"_3DyIPl","container":"_3shalB","cardsContainer":"_17wgcU"};